import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/models/dom';

// Import essential plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/wordcount';

; (function () {
  "use strict";

  var ArtForm = function () {
    const $editorElement = $('#editor');
    const $hiddenField = $('#hidden_editor');
    const $artForm = $('#art-form');

    var initializeTinyMCEEditor = function () {
      if (!$editorElement.length) return;

      // Get existing content
      const existingContent = $editorElement.val() || '';

      // Initialize TinyMCE with standard configuration
      tinymce.init({
        selector: '#editor',
        height: 600,
        menubar: 'file edit view insert format table tools',
        branding: false,
        promotion: false,
        license_key: 'gpl',
        base_url: 'https://cdn.jsdelivr.net/npm/tinymce@8.2.2',
        suffix: '.min',
        plugins: [
          'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
          'searchreplace', 'visualblocks', 'code', 'fullscreen',
          'media', 'table', 'wordcount'
        ],
        toolbar: 'undo redo | formatselect fontfamily fontsize | bold italic underline strikethrough | ' +
          'forecolor backcolor | alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist | outdent indent | link image charmap | code fullscreen',
        content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; font-size: 14px; line-height: 1.6; }',
        
        // Font family options
        font_family_formats: 
          'System Default=system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; ' +
          'Arial=Arial, Helvetica, sans-serif; ' +
          'Arial Black=Arial Black, Gadget, sans-serif; ' +
          'Comic Sans MS=Comic Sans MS, cursive; ' +
          'Courier New=Courier New, Courier, monospace; ' +
          'Georgia=Georgia, serif; ' +
          'Helvetica=Helvetica, Arial, sans-serif; ' +
          'Impact=Impact, Charcoal, sans-serif; ' +
          'Lucida Console=Lucida Console, Monaco, monospace; ' +
          'Lucida Sans Unicode=Lucida Sans Unicode, Lucida Grande, sans-serif; ' +
          'Palatino=Palatino Linotype, Book Antiqua, Palatino, serif; ' +
          'Tahoma=Tahoma, Geneva, sans-serif; ' +
          'Times New Roman=Times New Roman, Times, serif; ' +
          'Trebuchet MS=Trebuchet MS, Helvetica, sans-serif; ' +
          'Verdana=Verdana, Geneva, sans-serif; ' +
          'Roboto=Roboto, sans-serif; ' +
          'Open Sans=Open Sans, sans-serif; ' +
          'Lora=Lora, serif; ' +
          'Playfair Display=Playfair Display, serif; ' +
          'Merriweather=Merriweather, serif; ' +
          'Inconsolata=Inconsolata, monospace; ' +
          'Source Code Pro=Source Code Pro, monospace; ' +
          'Gill Sans=Gill Sans, Gill Sans MT, sans-serif; ' +
          'Garamond=Garamond, serif; ' +
          'Monaco=Monaco, monospace; ' +
          'Consolas=Consolas, monospace; ' +
          'Sans Serif=sans-serif; ' +
          'Serif=serif; ' +
          'Monospace=monospace; ' +
          'Cursive=cursive; ' +
          'Fantasy=fantasy',
        
        // Font size options
        font_size_formats: '5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt 40pt 44pt 48pt 52pt 56pt 60pt 64pt 72pt 80pt 96pt',
        
        // Special characters configuration - adds additional character ranges to default set
        charmap_append: [
          [0x2000, 0x206F], // General Punctuation (en dash, em dash, etc.)
          [0x2070, 0x209F], // Superscripts and Subscripts
          [0x20A0, 0x20CF], // Currency Symbols (€, £, ¥, etc.)
          [0x2100, 0x214F], // Letterlike Symbols (℅, ™, ©, ®, etc.)
          [0x2190, 0x21FF], // Arrows (←, →, ↑, ↓, etc.)
          [0x2200, 0x22FF], // Mathematical Operators (∑, ∫, √, etc.)
          [0x2300, 0x23FF], // Miscellaneous Technical
          [0x2460, 0x24FF], // Enclosed Alphanumerics (①, ②, etc.)
          [0x2500, 0x257F], // Box Drawing
          [0x2580, 0x259F], // Block Elements
          [0x25A0, 0x25FF], // Geometric Shapes (■, ▲, ●, etc.)
          [0x2600, 0x26FF], // Miscellaneous Symbols (☀, ☁, ♠, ♣, etc.)
          [0x2700, 0x27BF], // Dingbats
          [0x27C0, 0x27EF], // Miscellaneous Mathematical Symbols-A
          [0x27F0, 0x27FF], // Supplemental Arrows-A
          [0x2900, 0x297F], // Supplemental Arrows-B
          [0x2980, 0x29FF], // Miscellaneous Mathematical Symbols-B
          [0x2A00, 0x2AFF], // Supplemental Mathematical Operators
          [0x2B00, 0x2BFF]  // Miscellaneous Symbols and Arrows
        ],
        
        // Setup callback for syncing content
        setup: function(editor) {
          // Inject Google Fonts into editor iframe
          editor.on('init', function() {
            const iframe = editor.getContentAreaContainer().querySelector('iframe');
            if (iframe && iframe.contentDocument) {
              const head = iframe.contentDocument.head;
              const link = iframe.contentDocument.createElement('link');
              link.rel = 'stylesheet';
              link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&family=Inconsolata:wght@400;700&family=Open+Sans:wght@400;600;700&family=Lora:wght@400;700&family=Playfair+Display:wght@400;700&family=Merriweather:wght@400;700&family=Source+Code+Pro:wght@400;700&display=swap';
              head.appendChild(link);
            }
            
            // Initialize with existing content
            if (existingContent && existingContent.trim()) {
              editor.setContent(existingContent);
            }
            $hiddenField.val(editor.getContent());
          });
          
          // Update hidden field on change
          editor.on('input change', function() {
            $hiddenField.val(editor.getContent());
          });
        }
      });
    };

    var initializeFormSubmit = function () {
      $artForm.on('submit', function (e) {
        // Sync TinyMCE content before submit
        if (window.tinymce && window.tinymce.get('editor')) {
          const editor = window.tinymce.get('editor');
          $hiddenField.val(editor.getContent());
        }
      });
    }

    this.init = function () {
      initializeTinyMCEEditor();
      initializeFormSubmit();
    };
  };

  var ArtIndex = function () {
    var initializeCollapseButtons = function () {
      $("#toggle-sexual-arts").on("click", function () {
        const userConfirmed = confirm(
          "The arts in this section are sexual in nature. Do you wish to proceed?"
        );

        if (userConfirmed) {
          $("#sexual-arts-section").slideDown();
          $(this).hide();
        }
      });

      $("#toggle-religions-arts").on("click", function () {
        const userConfirmed = confirm(
          "The arts in this section are religion in nature. Do you wish to proceed?"
        );

        if (userConfirmed) {
          $("#religions-arts-section").slideDown();
          $(this).hide();
        }
      });
    }

    this.init = function () {
      initializeCollapseButtons();
    };
  }

  // The CMS form lives in Manage::StarArtsController, whose controller_name is
  // "star_arts" (namespaces are stripped), same as the public StarArtsController.
  const controller = $('body').data('controller');
  const action = $('body').data('action');
  const isStarArtsForm = controller === 'star_arts' && (action === 'new' || action === 'edit');
  const isStarArtsIndex = controller === 'star_arts' && action === 'index';

  if (isStarArtsForm) {
    var artForm = new ArtForm();
    artForm.init();
  } else if (isStarArtsIndex) {
    var artIndex = new ArtIndex();
    artIndex.init();
  }
})();
